import * as React from 'react';
import { Button } from '@readcloud/ui/button';
import { Checkbox } from '@readcloud/ui/checkbox';
import { Label } from '@readcloud/ui/label';
import { P } from '@readcloud/ui/typography';
import { FormMessage } from '@readcloud/ui/form';
import { Controller, useFormContext } from 'react-hook-form';
import { TermsFieldData } from './schemas/formFields';

interface ITermsAndConditionsProps {
  setTermsChecked: () => void;
}

const TermsAndConditions: React.FunctionComponent<ITermsAndConditionsProps> = ({setTermsChecked}) => {
  const { control, formState } = useFormContext<TermsFieldData>();

  return (
    <div className="rc-flex rc-flex-col rc-gap-6">
      <P>
        I am aware that I'm uploading to the ReadCloud platform, and I agree to
        abide by and respect all Copyright terms of any third party publisher
        and/or authors of such content and agree to the{' '}
        <Button asChild variant="link" className="rc-p-0">
          <a target="_blank" href="https://readcloud.com/terms-of-use/">
            ReadCloud Terms of Use
          </a>
        </Button>
        .
      </P>
      <Controller
        control={control}
        name="termsAndConditions"
        render={({ field }) => (
          <div className="rc-flex rc-flex-col rc-gap-2">
            <Label className="rc-flex rc-gap-2 rc-items-center">
              <Checkbox
                checked={!!field.value}
                onCheckedChange={(checked) => {
                  field.onChange(checked);
                }}
                onClick={setTermsChecked}
              />
              <span>I Agree</span>
            </Label>

            {formState.errors.termsAndConditions && (
              <FormMessage>
                {formState.errors.termsAndConditions.message}
              </FormMessage>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default TermsAndConditions;
